import React, { Fragment, Suspense, useState } from 'react';
import ProviderFavicon from 'components/ProviderFavicon';

import { subscribeToAuthenticationBus } from 'components/authentication/authentication-bus';
import { setupSSOTokenExpirationNotification } from 'components/authentication/authentication-checker';
import { ExpiredSessionLoginModal } from 'components/authentication/ExpiredSessionLoginModal';

import SpotlightMenu from 'components/SpotlightMenu';
import { AppRouter } from 'common/router';

const App = () => {
  const [authed, setAuthed] = useState(true);

  setupSSOTokenExpirationNotification();
  subscribeToAuthenticationBus((msg) => {
    setAuthed(msg === 'authorized');
  });

  return (
    <Suspense fallback={<Fragment />}>
      {!authed && <ExpiredSessionLoginModal />}
      <ProviderFavicon />
      {authed && <SpotlightMenu />}
      <AppRouter />
    </Suspense>
  );
};

export default App;
